module.exports = __webpack_public_path__ + "static/media/aasmund.d0587df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aasmund.png
// module id = 299
// module chunks = 0